import type { SpecificNavigationProp } from 'app/types/navigation';

export function openLandingSubscription(
  navigation: Pick<SpecificNavigationProp<'landing-page'>, 'navigate'>,
  isSmallUI: boolean,
  screen: 'my-plan' | 'payment',
) {
  if (isSmallUI) {
    navigation.navigate('profile', { screen, initial: false });
    return;
  }
  navigation.navigate('payment');
}
